import {Component, Inject, OnInit} from '@angular/core';
import {CompanyDataService} from '../company-data.service';
import {UserDataService} from '../../../../modules/auth/user-data.service';
import {Router} from '@angular/router';
import {DOCUMENT} from '@angular/common';
import * as CryptoJS from 'crypto-js';
import {environment} from '../../../../../../environments/environment';

@Component({
    selector: 'app-company-credits',
    templateUrl: './company-credits.component.html',
    styleUrls: ['./company-credits.component.scss'],
})
export class CompanyCreditsComponent implements OnInit {
    ephash;
    nonceGen;
    paymentReady = false;
    currentDate;
    userRoles;
    userIsClient = false;

    plainText:string;
    encryptText: string;
    encPassword: string;
    decPassword:string;
    conversionEncryptOutput: string;
    conversionDecryptOutput:string;
    userId;

    constructor(@Inject(DOCUMENT) private document: Document, private companyService: CompanyDataService, private userData: UserDataService, private router: Router) {
    }

    ngOnInit() {
        this.userData.getMainData().subscribe(data => {
            this.userId = data['userId'];
            this.userRoles = data['roles'];


            const role = this.userRoles.filter(currentRole => {
                    if (currentRole === 'ROLE_JobBoardsClient') {
                        this.userIsClient = true;
                        return
                    }
                }
            )[0];
        })
        this.companyService.ephash().subscribe(ephash =>{
            this.ephash = ephash['reason'];
            this.companyService.nonceGen().subscribe(nonceGen =>{
                this.nonceGen = nonceGen['reason'];
                this.currentDate = new Date('YmdHis');
                this.paymentReady = false;
            })
        })
    }

    loadPayment(planId){
        let prodId = '';

        if(planId === 1){
            prodId = '382244';
        }else if (planId === 2){
            prodId = '382245';
        }else if(planId === 3){
            prodId = '382246';
        }

        const data = `${this.userId}|${planId}`;

        // this.conversionEncryptOutput = CryptoJS.AES.encrypt(data, `${environment.encryptPass}` ).toString();

        // this.document.location.href = `https://sandbox.payu.ro/order/checkout.php?PRODS=${prodId}&QTY=1&ORDERSTYLE=nLWo4pSphLiRuY2e&INFO${prodId}=${this.conversionEncryptOutput}`;
        // this.paymentReady = true;
    }

}

